import { render, staticRenderFns } from "./LampItem.vue?vue&type=template&id=189b0d1e&scoped=true&"
import script from "./LampItem.vue?vue&type=script&lang=js&"
export * from "./LampItem.vue?vue&type=script&lang=js&"
import style0 from "./LampItem.vue?vue&type=style&index=0&id=189b0d1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189b0d1e",
  null
  
)

export default component.exports